<template>
  <transition name="fade">
    <div class="phrase-overlay" v-if="visible">
      <div class="create-phrase-wrap" style="width: 420px">
        <div class="list-create">
          <div class="newmessage-title">
            コメント列を追加
            <div class="flex-space"></div>
            <div class="newmessage-button" @click="close()">
              <font-awesome-icon :icon="['fal', 'times']" />
            </div>
          </div>
          <div class="list-create-box">
            <div class="list-create-name">コメントタイトル（任意・30文字以内）</div>
            <el-input size="small" v-model="title" maxlength="30" show-word-limit></el-input>
          </div>
          <div class="list-create-box">
            <el-checkbox class="checkbox-show checkbox-small" v-model="is_numeric_only">数字のみ入力</el-checkbox>
          </div>
          <div class="list-create-footer">
            <el-button size="small" :disabled="loading" @click="close()">キャンセル</el-button>
            <el-button size="small" type="primary" :disabled="loading" @click="submit()">追加</el-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
const root = process.env.VUE_APP_API;
const addCommentColumnAPI = root + "/api/list/add_comment_column";
import {
  isDuplicateNormalColumnTitle,
  LIST_COMMENT_DUPLICATE_TITLE_MESSAGE,
} from "@/utils/listCommentConst";

export default {
  name: "listCommentAddDialog",
  props: {
    visible: { type: Boolean, default: false },
    list_id: { type: [String, Number], required: true },
    comment_columns: { type: Array, default: () => [] },
  },
  data() {
    return {
      title: "",
      is_numeric_only: false,
      loading: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.title = "";
        this.is_numeric_only = false;
        this.loading = false;
      }
    },
  },
  methods: {
    close() {
      this.$emit("update:visible", false);
    },
    submit() {
      if (isDuplicateNormalColumnTitle(this.title, this.comment_columns)) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: LIST_COMMENT_DUPLICATE_TITLE_MESSAGE,
        });
        return;
      }
      this.loading = true;
      const params = new URLSearchParams();
      params.append("list_id", this.list_id);
      params.append("token", this.token);
      params.append("title", this.title);
      params.append("is_numeric_only", this.is_numeric_only ? "1" : "0");
      this.axios
        .post(addCommentColumnAPI, params)
        .then((response) => {
          this.loading = false;
          if (response.data.status === "OK") {
            this.$emit("added", response.data.comment_column);
            this.close();
          } else {
            this.$message({
              type: "error",
              offset: 7,
              showClose: true,
              message: response.data.message || "コメント列を追加できませんでした",
            });
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
